import { BiteLogMonerisEvent } from './bite_log_moneris_event.js';

export function name(event: BiteLogMonerisEvent): string {
  switch (event) {
    case BiteLogMonerisEvent.None:
      return 'ok';
    case BiteLogMonerisEvent.TerminalConnected:
      return 'terminal-connected';
    case BiteLogMonerisEvent.TerminalDisconnected:
      return 'terminal-disconnected';
    case BiteLogMonerisEvent.SaleTransactionRequested:
      return 'sale-transaction-requested';
    case BiteLogMonerisEvent.SaleTransaction:
      return 'sale-transaction';
    case BiteLogMonerisEvent.SaleTransactionError:
      return 'sale-transaction-error';
    case BiteLogMonerisEvent.DeviceSetup:
      return 'device-setup';
    case BiteLogMonerisEvent.DeviceSetupError:
      return 'device-setup-error';
    case BiteLogMonerisEvent.RefundTransactionRequested:
      return 'refund-transaction-requested';
    case BiteLogMonerisEvent.RefundTransaction:
      return 'refund-transaction';
    case BiteLogMonerisEvent.RefundTransactionError:
      return 'refund-transaction-error';
    case BiteLogMonerisEvent.Logs:
      return 'logs';
    case BiteLogMonerisEvent.TerminalUnresponsiveError:
      return 'terminal-unresponsive-error';
    case BiteLogMonerisEvent.TerminalRebootRequested:
      return 'terminal-reboot-requested';
    case BiteLogMonerisEvent.TerminalRebootSkipped:
      return 'terminal-reboot-skipped';
  }
}
